import React, { FC, useEffect, useState } from 'react';
import { DEFAULT_VISIBILITY_STATE, ListSidebarContext } from './const';
import { isMobileAny } from '../../../../utils/device';
import { getCookie, setCookie } from '../../../../utils/cookie';
import { useComponentDidUpdate } from '../../../../hooks/useComponentDidUpdate';
import { useLocation } from '@packages/router-dom';
import { useDispatch } from 'react-redux';
import { setIsExpanded as setIsExpandedAction } from '../../../sidebar/store/actions';

export const ListSidebarProvider: FC<React.PropsWithChildren> = ({ children }) => {
	const dispatch = useDispatch();
	const [isExpanded, setIsExpanded] = useState<boolean>(() => {
		if (isMobileAny) {
			return false;
		}

		const isExpanded = getCookie('sidebar_isExpandedView');
		const hasStoredValue = typeof isExpanded !== 'undefined' && isExpanded !== null;
		return hasStoredValue ? (JSON.parse(isExpanded) as boolean) : DEFAULT_VISIBILITY_STATE;
	});
	const [isCloseButtonDisabled, setIsCloseButtonDisabled] = useState(false);
	const location = useLocation();

	useComponentDidUpdate(() => {
		setCookie('sidebar_isExpandedView', isExpanded, {
			days: 100,
		});
		dispatch(setIsExpandedAction(isExpanded));
	}, [isExpanded]);

	useEffect(() => {
		if (isMobileAny) {
			return;
		}

		const isExpanded = getCookie('sidebar_isExpandedView') === 'true';

		setIsExpanded(isExpanded);
	}, [location.pathname]);

	return (
		<ListSidebarContext.Provider
			value={{
				isExpanded,
				setIsExpanded,
				isCloseButtonDisabled,
				setIsCloseButtonDisabled,
				toggle: () => setIsExpanded((prevState) => !prevState),
			}}
		>
			{children}
		</ListSidebarContext.Provider>
	);
};
